<template>
	<sf-data-table
		ref="table"
		:columns="columns"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		index
		paging
		:pageUnit="groups.pageUnit"
		:pageArray="screen.pageArray"
		:totalSize="groups.totalSize"
		:currentPage="groups.currentPage"
		@changedPage="changedPage"
	>
	</sf-data-table>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/TableDataManagement/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed,

		columns() {
			return [
				{
					label: this.getMessage_('SWCC000538'), //테이블
					prop: 'tableId',
					minWidth: '150px',
					clickEvent: this.clickEvent,
					highlight: true
				},
				{
					label: this.getMessage_('SWCC000541'), //저장기한
					prop: 'saveDays',
					minWidth: '160px'
				},
				{
					label: this.getMessage_('SWCC000542'), //삭제주기(일)
					prop: 'delCycleDay',
					minWidth: '150px'
				},
				{
					label: this.getMessage_('SWCC000317'), //삭제주기(시간)
					prop: 'delCycleTime',
					minWidth: '130px'
				},
				{
					label: this.getMessage_('SWCC000543'), //최근 삭제 행
					prop: 'lastDelCnt',
					minWidth: '120px'
				},
				{
					label: this.getMessage_('SWCC000544'), //최근 삭제 일자
					prop: 'lastDelDt',
					minWidth: '140px'
				},
				{
					label: this.getMessage_('SWCC000545'), //현재 행 개수
					prop: 'currRowCnt',
					minWidth: '120px'
				},
				{
					label: this.getMessage_('SWCC000891'), //관리유형
					prop: 'mgtType',
					minWidth: '120px'
				}
			];
		},
		rows() {
			return this.groups.data;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.$sf_toggleLoading(true);
			this.getTableDataManagementList_({ ...this.searchParams, currentPage: currentPageVal, pageUnit: pageUnitVal })
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		clickEvent(row) {
			this.setModalValue_({ key: 'flg', value: 'U' });
			this.setModalValue_({ key: 'tableId', value: row.tableId });
			this.setModalValue_({ key: 'saveDays', value: row.saveDays });
			this.setModalValue_({ key: 'delCycleDay', value: row.delCycleDay });
			this.setModalValue_({ key: 'delCycleTime', value: row.delCycleTime });
			this.defaultAssign_({ key: 'TableDataManagementModal', value: true });
		}
	}
};
</script>
<style></style>
